import {Injectable} from '@angular/core';
import {IResponseApi} from '@core/models';
import {ApiService} from '@core/services/api.service';
import {
  IAdminPageFeatureUsageData,
  IAdminPageInfoData,
  IAdminPageCheckTokenData,
  IAdminPageListData,
  IAdminPageListParams,
  IAdminPageLogsData,
  IAdminPageOrderBusinessResponse,
  IAdminPageSetExpiredParams,
  IAdminPageSetExpiredResponse,
  IAdminPageUpdateData,
  IAdminPageUpdateParams
} from '@shared/models/system';

@Injectable({providedIn: 'root'})
export class AdminPageService extends ApiService {
  list(params: IAdminPageListParams) {
    return this.postSystemRequest<IResponseApi<IAdminPageListData>>('/admin/page/list', params);
  }

  info(ids: string[]) {
    return this.postDocumentedRequest<IAdminPageInfoData>('info', {id: ids});
  }

  getLogs(fanpageId: string, next?: unknown[]) {
    return this.postDocumentedRequest<IAdminPageLogsData>('getlogs', {
      fanpageId, type: 1, size: 100, ...(next?.length ? {next} : {})
    });
  }

  featureUsage(id: string) {
    return this.postDocumentedRequest<IAdminPageFeatureUsageData>('featureusage', {id});
  }

  update(params: IAdminPageUpdateParams) {
    return this.postDocumentedRequest<IAdminPageUpdateData>('update', params);
  }

  setExpiredDate(params: IAdminPageSetExpiredParams) {
    return this.postSystemRequest<IAdminPageSetExpiredResponse>('/business/page/setexpireddate', params);
  }

  checkToken(id: string, channel: number) {
    return this.httpClient.post<IResponseApi<IAdminPageCheckTokenData>>(
      this.getBaseUrlApi('/business/page/checktoken'), {id, channel}
    );
  }

  getOrderBusiness(pageIds: string[]) {
    return this.httpClient.post<IAdminPageOrderBusinessResponse>(
      this.getBaseUrlApi('/admin/page/getorderbusiness'), {pageIds}
    );
  }

  /**
   * Super Admin mở phiên điều khiển một Page. API này thiết lập context Page ở
   * BE, vì vậy không được gửi kèm businessId của context đang xem trước đó.
   */
  pageControl(fanpageId: string) {
    return this.postUserRequest<IResponseApi<Record<string, unknown>>>('/auth/pagecontrol', {fanpageId});
  }

  private postDocumentedRequest<T>(action: string, body: object) {
    // JSON preserves empty strings, which /update requires to clear a page note.
    return this.httpClient.post<IResponseApi<T>>(this.getBaseUrlApi(`/admin/page/${action}`), body);
  }
}
